<div class="client-property-label">
	<span>{{ 'product-details.company-details.company-description' | translate }}</span>
	<change-label [visible]="isCompanyDescriptionChanged()" [changeSet]="changeSet"></change-label>
</div>
<div id="company-description-{{standardNameWithTimestamp()}}" class="client-property">
	{{ product.companyDescription }}
	@if (translationExists('companyDescription')) {
		<translation-field [standard]="standardName()" [previewMode]="!translateClientsData"
						   [translatedText]="getTranslation('companyDescription')" [translationSubject]="'companyDescription'"></translation-field>
	}
</div>

<div class="client-property-label">
	<span>{{ 'product-details.company-details.total-employees' | translate }}</span>
	<change-label [visible]="areEmployeesChanged()" [changeSet]="changeSet"></change-label>
</div>
<div id="number-of-employees-{{standardNameWithTimestamp()}}" class="client-property">
	{{ numberOfEmployees }}
</div>

<div class="scope-description">
	<div class="client-property-label label-row">
		<span>{{ 'product-details.company-details.scope-description' | translate }}</span>
		<change-label [visible]="isScopeDescriptionChanged()" [changeSet]="changeSet"></change-label>
	</div>
	<div class="radio-row form-row">
		<div class="radio-column">
			<nb-radio id="scope-description-needs-narrowing-{{standardNameWithTimestamp()}}" [name]="'scopeDescriptionNeedsNarrowing' + standardNameWithTimestamp()" [checked]="true" status="primary">
				{{ !product.scopeDescriptionNeedsNarrowing | booleanDisplay }}
			</nb-radio>
		</div>
		<div class="radio-description-column">
			{{ 'product-details.company-details.scope-description-needs-narrowing' | translate: {standard: product.standard.name | standardName} }}
		</div>
	</div>

	@if (product.scopeDescriptionNeedsNarrowing) {
		<div id="scope-description-{{standardNameWithTimestamp()}}" class="client-property">
			{{ product.scopeDescription }}
			@if (translationExists('scopeDescription')) {
				<translation-field [standard]="standardName()" [previewMode]="!translateClientsData"
								   [translatedText]="getTranslation('scopeDescription')" [translationSubject]="'scopeDescription'"></translation-field>
			}
		</div>
	}
</div>
